import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IAddressData } from '@df/session/api/address-book/address';
import isEmpty from 'lodash-es/isEmpty';

@Component({
    selector: 'address-long',
    templateUrl: 'address-long.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class AddressLongComponent {
    @Input()
    addressData: IAddressData = {};

    get lines() {
        if (isEmpty(this.addressData)) {
            return [];
        }
        return [
            ['prefix', 'firstname', 'lastname'],
            ['company'],
            ['street_1'],
            ['street_2', 'street_3'],
            ['city'],
            ['state'],
            ['country'],
            ['postcode'],
            ['telephone']
        ]
            .map(fields => fields.map(field => this.addressData[field]).filter(i => !!i))
            .filter(i => i.length);
    }
}
